import type { HTMLAttributes, ReactNode } from 'react';
import { Icon } from '@/ui/icons/Icon';
import { cx } from './cx';
import styles from './Panel.module.css';

interface PanelProps extends HTMLAttributes<HTMLElement> {
  /** Accessible name of the region. */
  readonly label: string;
}

/** Bordered surface used for the side panels and the bottom panel. Exposed as a landmark. */
export function Panel({ label, className, children, ...rest }: PanelProps) {
  return (
    <section aria-label={label} className={cx(styles.panel, className)} {...rest}>
      {children}
    </section>
  );
}

interface PanelHeaderProps {
  readonly title: string;
  readonly icon?: string;
  readonly actions?: ReactNode;
}

export function PanelHeader({ title, icon, actions }: PanelHeaderProps) {
  return (
    <header className={styles.header}>
      {icon !== undefined && <Icon name={icon} size={18} />}
      <h2 className={styles.title}>{title}</h2>
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}

/** Scrollable content area of a panel. */
export function PanelBody({ children }: { children: ReactNode }) {
  return <div className={styles.body}>{children}</div>;
}
